import { Coins, DollarSign, TrendingUp, Clock, Trophy } from "lucide-react";

function formatNumber(n) {
  if (n == null) return "0";
  return n.toLocaleString("pt-BR");
}

function formatCurrency(v) {
  if (v == null) return "R$ 0,00";
  return "R$ " + v.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export default function DoletasBalanceCard({ data, children }) {
  if (!data) return null;

  return (
    <div className="bg-gradient-to-br from-[#0A2F3D] to-[#163d4f] rounded-xl lg:rounded-2xl p-5 lg:p-6 pb-6 lg:pb-7 text-white shadow-lg overflow-hidden">
      <div className="flex items-center gap-2 mb-4">
        <Coins className="w-5 h-5 text-amber-400" />
        <h3 className="text-base lg:text-lg font-bold">Programa DOLETAS</h3>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 lg:gap-4">
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 lg:p-4 text-center">
          <Coins className="w-5 h-5 mx-auto mb-1 text-amber-400" />
          <p className="text-xl lg:text-2xl font-bold" data-testid="doletas-balance">{formatNumber(data.balance)}</p>
          <p className="text-xs text-white/60">Doletas</p>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 lg:p-4 text-center">
          <DollarSign className="w-5 h-5 mx-auto mb-1 text-emerald-400" />
          <p className="text-xl lg:text-2xl font-bold" data-testid="doletas-reais">{formatCurrency(data.balance_reais)}</p>
          <p className="text-xs text-white/60">Valor em R$</p>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 lg:p-4 text-center">
          <TrendingUp className="w-5 h-5 mx-auto mb-1 text-blue-400" />
          <p className="text-xl lg:text-2xl font-bold">{formatNumber(data.total_earned)}</p>
          <p className="text-xs text-white/60">Total Ganho</p>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 lg:p-4 text-center">
          <Clock className="w-5 h-5 mx-auto mb-1 text-amber-300" />
          <p className="text-xl lg:text-2xl font-bold">{formatNumber(data.total_pending)}</p>
          <p className="text-xs text-white/60">Pendente</p>
        </div>
      </div>
      <p className="text-xs text-white/40 mt-3 text-center">100 doletas = R$ 1,00 | Validade: 1 ano</p>
      {data.gala_eligible && (
        <div className="mt-3 bg-amber-500/20 border border-amber-400/30 rounded-xl p-3 text-center">
          <Trophy className="w-5 h-5 mx-auto mb-1 text-amber-400" />
          <p className="text-sm font-medium text-amber-300">Voce esta elegivel para a Noite de Gala!</p>
        </div>
      )}
      {children}
    </div>
  );
}
